import { render, staticRenderFns } from "./EditAdministratorModal.vue?vue&type=template&id=ed58eb3e&"
import script from "./EditAdministratorModal.vue?vue&type=script&lang=js&"
export * from "./EditAdministratorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports